import React, { useContext } from 'react';
import AppContext from '@context';
import JourneysItem from './JourneysItem';
import * as Styled from './JourneysListStyles';

function JourneysList() {
  const {
    state: { journeysWaitingConfirmDelivery },
  } = useContext(AppContext);
  const { data: journeys } = journeysWaitingConfirmDelivery;

  function handleRenderJourneys() {
    if (!journeys.length) {
      return null;
    }

    return journeys.map((journey) => (
      <JourneysItem key={journey.id} {...journey} />
    ));
  }

  return <Styled.Wrapper>{handleRenderJourneys()}</Styled.Wrapper>;
}

export default JourneysList;
